export const noticeConstants = {
    LOAD_REQUEST: 'NOTICE_LOAD_REQUEST',
    LOAD_SUCCESS: 'NOTICE_LOAD_SUCCESS',
    LOAD_FAILURE: 'NOTICE_LOAD_FAILURE',

    SEARCH_REQUEST: 'NOTICE_SEARCH_REQUEST',
    SEARCH_SUCCESS: 'NOTICE_SEARCH_SUCCESS',
    SEARCH_FAILURE: 'NOTICE_SEARCH_FAILURE',

    SELECT_REQUEST: 'NOTICE_SELECT_REQUEST',

    DETAILS_REQUEST: 'NOTICE_DETAILS_REQUEST',
    DETAILS_SUCCESS: 'NOTICE_DETAILS_SUCCESS',
    DETAILS_FAILURE: 'NOTICE_DETAILS_FAILURE',
}
